import { render } from "./OrderDetailView.vue?vue&type=template&id=46510f88&ts=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=ts"
export * from "./OrderDetailView.vue?vue&type=script&lang=ts"

import "./OrderDetailView.vue?vue&type=style&index=0&id=46510f88&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__